import React, { useState } from "react";
import Slider from "react-slick";
import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";
import STWCard from "./Card";
import Edit from "./Edit";
function SampleNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    />
  );
}

function SamplePrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block" }}
      onClick={onClick}
    />
  );
}

const SchoolsWatch = (props) => {
  const [edit, setEdit] = useState(null);

  const settings = {
    dots: false,
    lazyLoad: true,
    infinite: props.stw && props.stw.length > 3 ? true : false,
    speed: 1000,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  let content;
  if (props.stw && props.stw.length > 0) {
    content = props.stw.map((school, id) => (
      <STWCard
        edit={props.superAdmin}
        data={school}
        editSTW={() => setEdit(school)}
        key={id}
      />
    ));
  } else {
    content = <p>Loading</p>;
  }
  return (
    <>
      <Slider className="main-slider" {...settings}>
        {content}
      </Slider>
      {edit && <Edit open={edit} close={() => setEdit(null)} />}
    </>
  );
};

const mapStateToProps = (state) => {
  let stw = [];
  const stwData = state.firestore.ordered.schoolstowatch;
  const schoolData = state.firestore.data.schools;

  if (
    stwData &&
    schoolData &&
    stwData.length > 0 &&
    Object.keys(schoolData).length > 0
  ) {
    stw = stwData.map((e) => {
      let data = null;
      if (e.school && schoolData[e.school]) {
        const school = schoolData[e.school];
        data = { ...e, schoolName: school.name };
      } else if (e.school && !schoolData[e.school]) {
        data = { ...e, schoolName: e.school };
      }
      return data;
    });
  }

  // advocateWikiOrder

  return {
    stw,
    auth: state.firebase.auth,
    superAdmin: state.auth.superAdmin,
  };
};

export default compose(
  connect(mapStateToProps),
  firestoreConnect(() => [
    {
      collection: "schoolstowatch",
      orderBy: ["modifiedAt", "desc"],
    },
    {
      collection: "schools",
      orderBy: ["name", "asc"],
    },
  ])
)(SchoolsWatch);
